<template>
  <!-- Content inside wrapper and container -->
  <div class="relative z-2">
    <div class="container mx-auto p-5">
      <div class="text-left mb-3 mt-3">
        <h4 class="text-3xl font-bold text-gray-600">{{ $translate('Choose Your Option') }}</h4>
        <p class="text-lg mt-2 text-gray-500">
          {{ $translate('You can either buy a single ticket or choose a package that includes the event.') }}
        </p>
      </div>

      <!-- Row structure for EventComponent and PackageComponent -->
      <div class="selection-item flex flex-row justify-between gap-11 mt-8">
        <!-- Single Option -->
        <div class="w-full" v-for="event in products?.events" :key="event.id">
          <EventComponent :event="event" @select="addItemToCart('event', event)" />
        </div>

        <!-- Package Option -->
        <div v-if="products?.packages?.length > 0" class="w-full">
          <PackageComponent :pkg="products.packages[currentPackageIndex]" :currentPackageIndex="currentPackageIndex"
            :totalPackages="products.packages.length" :nextPackage="nextPackage" :prevPackage="prevPackage"
            @select="addItemToCart('package', products.packages[currentPackageIndex])"
            @selectItem="addItemToCart($event.type, $event.item)" />
        </div>
      </div>
    </div>
  </div>
</template>



<script>
import { ref, inject } from 'vue';
import EventComponent from '@/components/payment/components/EventComponent.vue';
import PackageComponent from '@/components/payment/components/PackageComponent.vue';
/*import { cookie } from '@/utils/cookie';
import { notify } from 'notiwind';
import { translate } from '@/utils/translate';
*/
export default {
  components: {
    EventComponent,
    PackageComponent,
  },
  props: {
    products: {
      type: Object,
      required: true,
    },
  },
  setup(props, { emit }) {
    const cartStore = inject('cartStore');
    const currentPackageIndex = ref(0);
    const addItemToCart = async (type, product, showError = true) => {
      let status = cartStore.addItemToCart(type, product, showError);
      if (status) {
        emit('next-step');
      }
    }
    /* const addItemToCart = async (type, product, showError = true) => {
       const sessionId = cookie();
       const id = product.id;
 
       try {
         const response = await fetch(
           `${window.vueAppConfig.endpoint}/api/v2/events/cart/add?id=${id}&brand_id=${window.vueAppConfig.info.id}&type=${type}&session_id=${sessionId}`,
           {
             method: 'POST',
             headers: {
               'Content-Type': 'application/json'
             }
           }
         );
 
         const data = await response.json();
 
         if (data.status) {
           await cartStore.fetchCartContent(window.vueAppConfig.info.id);
           selectedItems.value.push(product);
           emit('item-added', selectedItems.value);
         } else if (showError) {
           notify({
             title: translate("Error"),
             text: data.message ?? translate("Something went wrong"),
             type: "error",
             group: "error"
           }, 15000);
         }
       } catch (error) {
         console.error('Error adding to cart:', error);
       }
     };*/



    const nextPackage = () => {
      if (currentPackageIndex.value < props.products.packages.length - 1) {
        currentPackageIndex.value++;
      }
    };

    const prevPackage = () => {
      if (currentPackageIndex.value > 0) {
        currentPackageIndex.value--;
      }
    };

    // Watch for automatic selection
    /*  watch(() => props.products, (newProducts) => {
        if (newProducts?.events?.length === 1 && newProducts.packages?.length === 0) {
          addItemToCart('event', newProducts.events[0], false);
          emit('next-step', selectedItems.value);
        }
      }, { immediate: true });
  */
    return {
      addItemToCart,
      currentPackageIndex,
      nextPackage,
      prevPackage
    };
  },
};
</script>

<style scoped>
@media (max-width: 900px) {
  .selection-item {
    flex-direction: column;
    gap: 0px;
    width: 80%;
    margin: 0 auto;
  }

  .container {
    width: 100%;
  }
}
</style>
